import { AxiosResponse } from 'axios'
import axios from '~/lib/axios'
import { csrfToken } from '~/core/vars'

export const postOripaLotteryResult = (
  lotteryId: number,
  amount: string,
  totalPrice: string,
  payPoints: string
): Promise<AxiosResponse<Api.Oripa.LotteryResults.Post.Response>> => {
  const token = csrfToken()
  if (!token) throw TypeError('null csrf token')

  const params = new FormData()
  params.append('authenticity_token', token)
  params.append('lottery_result[amount]', amount)
  params.append('lottery_result[total_price]', totalPrice)
  params.append('lottery_result[pay_points]', payPoints)

  return axios.post(`/oripa/lotteries/${lotteryId}/lottery_results`, params)
}

export const getOripaLotteriesBillingAmount = (
  lotteryId: number,
  purchaseAmount: number,
  payPoints: number,
  requestKey: string
): Promise<AxiosResponse<Api.Oripa.Lotteries.BillingAmount.Get.Response>> => {
  const query = `request_key=${requestKey}&oripa_lottery[pay_points]=${payPoints}&oripa_lottery[purchase_amount]=${purchaseAmount}`
  const url = `/api/oripa/lotteries/${lotteryId}/billing_amounts?${query}`
  return axios.get(url)
}
